import { SideMenuItemType } from './Types';
import HomeImage from '../assets/img/home.png';
import Onboarding from '../assets/img/onboarding.png';
import AssignGrid from '../assets/img/assign-grid.png';
import TrackLocation from '../assets/img/track-Location.png';
import Attendance from '../assets/img/attendance.png';
import Leads from '../assets/img/leads.png';
import SetTarget from '../assets/img/set-targets.png';
import MarketingActivity from '../assets/img/marketing-activity.png';
// import Rewards from '../assets/img/rewards.png';
// import Reimbursement from '../assets/img/reimbursement.png';
import EmployeeData from '../assets/img/employee-data.png';
// import Reports from '../assets/img/reports.png';
import AdminSetting from '../assets/img/admin-setting.png';
import TaskAssigned from '../assets/img/task-assigned.svg';
// import Remunaration from '../assets/img/remunaration.png';
import Claims from '../assets/img/claims copy.png';
// import {
//   APPLY_REIMBURSEMENT_ALLOWED_ROLES_OMDC,
//   APPROVE_REIMBURSEMENT_ALLOWED_ROLES_OMDC,
// } from './Constant';

export const ROLE_IDS = [1, 2, 3, 4, 5, 8, 9, 10];
export const ROLE_IDS_IIB = [1, 2, 3, 4, 5, 8, 9, 10, 15];
export const SET_TARGET_ROLE_IDS = [1, 3, 4, 5, 8];
export const ROLE_IDS_OMDC = [
  1, 2, 3, 4, 5, 8, 9, 10, 12, 18, 19, 20, 23, 27, 28,
];
export const ROLE_IDS_OMDC_APPROVE_LEAVES = [
  1, 2, 3, 4, 5, 8, 9, 10, 18, 19, 20, 23, 27, 28,
]; // OMDC Users
export const ROLE_IDS_OMDC_IIB_HOME = [
  1, 2, 3, 4, 5, 8, 9, 10, 12, 15, 18, 19, 20, 23, 27, 28,
];
export const ROLE_OMDC = [11, 12, 21, 22, 16, 17, 18, 19, 20, 23, 27, 28];
export const ROLE_IN_POPUP = [9, 11]; // Admin AND Surveyor. AND  PMFBY Coordinator, CCE Expert when these available.

export const ROLE_IDS_BANCA = [24, 25];
export const ROLE_KEY_ACCOUNT_MANAGER = [25];
export const ROLE_VP_PARTNERSHIP = [24];
export const ZONE_ACCESS_ROLES = [4];
export const STATE_ACCESS_ROLES = [5, 25, 18, 19, 27];
export const DISTRICT_ACCESS_ROLES = [6, 16, 17];
export const PINCODES_ACCESS_ROLES = [7, 11, 21, 22];
export const ROLE_AMO = [33];

export const RABC: SideMenuItemType[] = [
  {
    title: 'Home',
    icon: HomeImage,
    route: 'home',
    roles: [...ROLE_IDS_OMDC_IIB_HOME, ...ROLE_IDS_BANCA, ...ROLE_AMO],
  },
  {
    title: 'User Onboarding',
    icon: Onboarding,
    route: 'user-onboarding',
    roles: ROLE_IDS_IIB,
    submenu: true,
    submenuItems: [
      {
        title: 'Registration Approval',
        route: 'registration-approval',
        roles: ROLE_IDS_IIB,
      },
      {
        title: 'KYC Verification',
        route: 'kyc-verification',
        roles: ROLE_IDS_IIB,
      },
    ],
  },
  {
    title: 'Assign Grid',
    icon: AssignGrid,
    route: 'assign-grid',
    roles: ROLE_IDS,
  },
  {
    title: 'Track Location',
    icon: TrackLocation,
    route: 'track-location',
    roles: [...ROLE_IDS_OMDC, ...ROLE_VP_PARTNERSHIP, ...ROLE_AMO], // Added OMDC roles to existing roles
    submenu: false,
    submenuItems: [
      {
        title: 'Real Time Track',
        route: 'realtime-track',
        roles: [...ROLE_IDS_OMDC, ...ROLE_VP_PARTNERSHIP, ...ROLE_AMO], // Added OMDC roles to existing roles
      },
      {
        title: 'Historical Track',
        route: 'historical-track',
        roles: [...ROLE_IDS_OMDC, ...ROLE_VP_PARTNERSHIP, ...ROLE_AMO], // Added OMDC roles to existing roles
      },
    ],
  },
  {
    title: 'Task Assigned',
    icon: TaskAssigned,
    route: 'task-assigned',
    roles: [...ROLE_IDS_OMDC, ...ROLE_AMO], // Added OMDC roles to existing roles
    submenu: true,
    submenuItems: [
      {
        title: 'Create Task',
        route: 'create-task',
        roles: [...ROLE_IDS_OMDC, ...ROLE_AMO], // Added OMDC roles to existing roles
      },
      {
        title: 'View Task',
        route: 'view-task',
        roles: [...ROLE_IDS_OMDC, ...ROLE_AMO], // Added OMDC roles to existing roles
      },
    ],
  },
  {
    title: 'Attendance',
    icon: Attendance,
    route: 'attendance',
    roles: [...ROLE_IDS_OMDC, ...ROLE_VP_PARTNERSHIP, ...ROLE_AMO], // Added OMDC roles to existing roles
    submenu: true,
    submenuItems: [
      {
        title: 'View Attendees',
        route: 'view-attendees',
        roles: [...ROLE_IDS_OMDC, ...ROLE_VP_PARTNERSHIP, ...ROLE_AMO], // Added OMDC roles to existing roles
      },
      {
        title: 'Approve Leaves',
        route: 'approve-leaves',
        roles: ROLE_IDS, // Added OMDC roles to existing roles
      },
      {
        title: 'Leave History',
        route: 'leave-history',
        roles: ROLE_IDS, // Added OMDC roles to existing roles
      },
    ],
  },
  {
    title: 'Leads',
    icon: Leads,
    route: 'leads',
    roles: ROLE_IDS,
    submenu: true,
    submenuItems: [
      {
        title: 'Create Lead',
        route: 'create-lead',
        roles: ROLE_IDS,
      },
      {
        title: 'View Lead',
        route: 'view-lead',
        roles: ROLE_IDS,
      },
    ],
  },
  {
    title: 'Set Targets',
    icon: SetTarget,
    route: 'set-targets',
    roles: SET_TARGET_ROLE_IDS,
  },
  // {
  //   title: 'Track a Complaint',
  //   icon: TrackLocation,
  //   route: 'track-complaint',
  //   roles: ROLE_IDS,
  //   submenu: false,
  //   submenuItems: [
  //     {
  //       title: 'Raise a Compliant',
  //       route: 'raise-compliant',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Track a Compliant',
  //       route: 'track-compliant',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Compliant Dashboard',
  //       route: 'Compliant-dashboard',
  //       roles: ROLE_IDS,
  //     },
  //   ],
  // },
  {
    title: 'Sales Activity',
    icon: MarketingActivity,
    route: 'activity',
    roles: ROLE_IDS_OMDC,
    submenu: true,
    submenuItems: [
      {
        title: 'Create Sales Activity',
        route: 'create-activity',
        roles: ROLE_IDS_OMDC,
      },
      {
        title: 'View Sales Activity',
        route: 'view-activity',
        roles: ROLE_IDS_OMDC,
      },
    ],
  },
  // {
  //   title: 'Top Performers',
  //   icon: Rewards,
  //   route: 'top-performers',
  //   roles: ROLE_IDS,
  //   submenu: false,
  //   submenuItems: [
  //     {
  //       title: 'Top Performer',
  //       route: 'top-performer',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Nomination Submission',
  //       route: 'nomination-submission',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Approval Submission',
  //       route: 'approval-submission',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Performance Evaluation',
  //       route: 'performance-evaluation',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: "KPI's",
  //       route: 'kpi',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Spot Awards',
  //       route: 'spot-awards',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Wall of Fame',
  //       route: 'wall-of-Fame',
  //       roles: ROLE_IDS,
  //     },
  //     {
  //       title: 'Review',
  //       route: 'review',
  //       roles: ROLE_IDS,
  //     },
  //   ],
  // },
  // {
  //   title: 'Remuneration',
  //   icon: Remunaration,
  //   route: 'view-remuneration',
  //   roles: ROLE_IDS,
  // },
  // {
  //   title: 'Reimbursement',
  //   icon: Reimbursement,
  //   route: 'reimbursement',
  //   roles: ROLE_IDS_OMDC,
  //   submenu: true,
  //   submenuItems: [
  //     {
  //       title: 'Apply Reimbursement',
  //       route: 'apply-reimbursement',
  //       roles: APPLY_REIMBURSEMENT_ALLOWED_ROLES_OMDC,
  //     },
  //     {
  //       title: 'Approve Reimbursement',
  //       route: 'approve-reimbursement',
  //       roles: APPROVE_REIMBURSEMENT_ALLOWED_ROLES_OMDC,
  //     },
  //   ],
  // },
  {
    title: 'Claims',
    icon: Claims,
    route: 'claim-search',
    roles: ROLE_IDS,
  },
  {
    title: 'Employee Data',
    icon: EmployeeData,
    route: 'employee',
    roles: ROLE_IDS_OMDC, // Added OMDC roles
  },
  // {
  //   title: 'Reports',
  //   icon: Reports,
  //   route: 'reports',
  //   roles: ROLE_IDS,
  // },
  // {
  //   title: 'Dashboard',
  //   icon: AdminSetting,
  //   route: 'dashboard',
  //   roles: ROLE_IDS,
  // },
  {
    title: 'IEC Ops',
    icon: AdminSetting,
    route: 'ice-ops',
    roles: ROLE_IDS_OMDC,
  },
  {
    title: 'CHM Ops',
    icon: AdminSetting,
    route: 'chm-ops',
    roles: ROLE_IDS_OMDC,
  },
  {
    title: 'Admin Settings',
    icon: AdminSetting,
    route: 'adminSettings',
    roles: [9, 8, 3, 23, 28], //Admin, VP-Sales and CGO
    submenu: true,
    submenuItems: [
      {
        title: 'Employee Information',
        route: 'employee-information',
        roles: [9, 23, 28],
      },
      {
        title: 'Role Management',
        route: 'role-management',
        roles: [9, 8, 3],
      },
      {
        title: 'Welcome Videos',
        route: 'welcome-videos',
        roles: [9, 28],
      },
      {
        title: 'Banner',
        route: 'banner',
        roles: [9],
      },
      {
        title: 'Latest Updates',
        route: 'latest-updates',
        roles: [9, 28],
      },
      {
        title: 'Gallery',
        route: 'gallery',
        roles: [9, 28],
      },
      {
        title: 'Knowledge Center',
        route: 'knowledge-center',
        roles: [9, 28],
      },
    ],
  },
];
